'use client';
import History, { HistoryProps } from './History';
import SweepHistoryTable from './SweepHistoryTable';
import VoterHistoryTable from './VoterHistoryTable';

export interface HistoryContainerProps {}

const HistoryContainer = ({}: HistoryContainerProps) => {
  return (
    <History
      sweepHistory={<SweepHistoryTable />}
      topVoters={<VoterHistoryTable />}
    />
  );
};

export default HistoryContainer;
